<!--
 * @Author: CHY
 * @Date: 2022-12-13 14:13:24
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-24 17:52:51
 * @FilePath: \liancan-public-screen-school\src\components\itemTitle.vue
-->
<template>
    <div class="page_index">
        <div v-if="subTitle" class="page_unit">{{subTitle}}</div>
        <div class="flex flex_center">
            <div>
                <img :src="imgLeftList" alt="">
            </div>
            <div>{{title}}</div>
            <div>
                <img :src="imgRightList" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'itemTitle',
        props: {
            subTitle: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: '标题'
            },
            imgLeftList: {
                type: String,
                default: require("@/assets/images/icon_left.png")
            },
            imgRightList: {
                type: String,
                default: require("@/assets/images/icon_right.png")
            }

        },
        data() {
            return {}
        },
        components: {},
        created() {},
        computed: {},
        watch: {},
        methods: {}
    }
</script>

<style lang='scss' scoped>
    .page_index {
        @include font(28, #7BBCFF, center);
        font-weight: bold;
        margin-bottom: vh(26);

        img {
            width: vh(10);
            height: vh(18);
            margin: 0 vh(20);
        }

        .page_unit {
            height: vh(25);
            @include font(18, #009DD7, right);
            margin-right: vh(30);
        }
    }
</style>